import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { Driver, driverSchema } from '../schemas/driver.schema';

/**
 * Updates Drivers
 * @param driver The Drivers being updated
 * @returns Data Object containing whether the drivers were edited
 */
export function putDrivers(this: unknown, drivers: Partial<Driver>[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).driversUrl, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(drivers),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(driverSchema),
        message: z.string().nullable(),
      })
    )
  );
}
